/* global axios */
import ApiClient from './ApiClient';

// VibeVox: проверка ключа модели (Gemini/OpenAI-совместимый) и получение списка
// доступных по ключу моделей. Endpoint: POST /integrations/captain_llm/verify.
class VibevoxLlmAPI extends ApiClient {
  constructor() {
    super('integrations', { accountScoped: true });
  }

  verifyModels(apiKey) {
    return axios.post(`${this.baseUrl()}/integrations/captain_llm/verify`, {
      api_key: apiKey,
    });
  }
}

export default new VibevoxLlmAPI();
